export const menteeStatusMap = {
  EXPERT: '专家再次修改',
  MENTOR: '提交导师修改'
}
export const expertStatusMap = {
  EXPERT: '专家提交给导师',
  MENTEE: '您已提交给导师'
}
